import { Skeleton } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import PreviewBar from './PreviewBar';

// DVLP-7601: skeleton that matches the read-only preview layout. The real
// PreviewBar sits on top — it shows no collection data, and its license
// selector, unlocked count and toggle each render their own loading state,
// so the bar is identical before and after load with no layout shift. Below
// it: a static-looking title/description block, then section-card outlines.
// Kept separate from EditSkeleton so it doesn't flash edit-mode chrome.

function PreviewDetailsSkeleton() {
  return (
    <div
      className="flex pb-10 justify-between gap-6"
      data-intercom-target="preview-skeleton-details"
    >
      <div className="md:mr-11 w-3/5">
        <Skeleton className="w-4/5 h-10" variant="text" size="xl" />
        <div className="mt-4 space-y-2">
          <Skeleton className="w-full" variant="text" size="sm" />
          <Skeleton className="w-11/12" variant="text" size="sm" />
          <Skeleton className="w-3/4" variant="text" size="sm" />
        </div>
      </div>
      <Skeleton className="w-32 h-24" variant="rectangle" />
    </div>
  );
}

function SectionCardSkeleton() {
  return (
    <div
      className="mx-auto xl:container px-6 md:px-14"
      data-intercom-target="preview-skeleton-section"
    >
      <div className="bg-card border border-border rounded-lg p-6">
        <Skeleton className="w-1/3 h-6 mb-2" variant="text" size="lg" />
        <Skeleton className="w-2/3 h-4 mb-6" variant="text" size="sm" />
        <div className="grid gap-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="rounded-md border border-border overflow-hidden">
              <Skeleton className="w-full h-32" variant="rectangle" />
              <div className="p-3 space-y-2">
                <Skeleton className="w-4/5" variant="text" size="sm" />
                <Skeleton className="w-1/2" variant="text" size="xs" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function PreviewSkeleton() {
  return (
    <div className="flex flex-1 flex-col" data-intercom-target="preview-skeleton">
      <PreviewBar />
      <div className="flex flex-1">
        <div className="flex-1">
          <div className="mx-auto box-border px-6 pb-8 pt-11 xl:container md:px-14">
            <PreviewDetailsSkeleton />
          </div>
          <div className="flex flex-col gap-8">
            <SectionCardSkeleton />
            <SectionCardSkeleton />
          </div>
        </div>
      </div>
    </div>
  );
}

export default observer(PreviewSkeleton);
